import styled, { css } from 'styled-components';
import { absFull, contentCentered } from 'helpers/styles.js';

/**
 * Top level containers
 */
export const RequestContainer = styled.div`
  position: relative;
  width: 950px;
  height: 600px;

  @media (min-width: 1200px) {
    width: 1100px;
  }
`;

export const StepsContainer = styled.div`
  ${absFull(0, 0, '100px', 0)};
`;

/**
 * Progress management
 */
export const ProgressStep = styled.div`
  position: relative;
  display: inline-block;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.graphPalette[3]};
  min-width: 100px;
  padding-right: 12px;
  text-align: left;
  width:  ${({ width }) => width || 'auto'};
`;

export const ProgressBar = styled.div`
  position: relative;
  height: 2px;
  width: 100%;
  margin-bottom: 12px;
  background: #E4E5E9;

  &:after {
    content: '';
    ${absFull(0, 'auto', 0, 0)};
    background: ${({ theme }) => theme.colors.palette[7]};
    width: ${({ isValid }) => isValid ? '100%' : 0};
    transition: all .8s cubic-bezier(0.29, 1.02, 0.58, 1);
  }
`;

export const ProgressLoading = styled.div`
  position: relative;
  height: 2px;
  width: 100%;
  margin-top: 19px;
  background: linear-gradient(90deg,
  rgba(45, 139, 255, 0.16) 0%,
  #2D8BFF 22.67%,
  rgba(45, 139, 255, 0.49) 43.24%,
  rgba(45, 139, 255, 0.84) 61.69%,
  rgba(45, 139, 255, 0.3) 81.2%,
  rgba(45, 139, 255, 0.7) 101.23%);
`;

/**
 * Buttons section
 */

export const ButtonContainer = styled.div`
  ${absFull('auto', 0, 0, 0)};
  height: 100px;
  background: #FBFBFC;
  ${contentCentered};
`;

export const ProgressStepsContainer = styled.div`
  ${absFull('30px', '150px', 'auto', '150px')};
`;


export const ModalButton = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  cursor: pointer;
  padding: 0 14px;
  font-weight: 500;
  font-size: 9px;
  line-height: 30px;
  align-items: center;
  letter-spacing: 2px;
  color: #2D8BFF;
  display: inline-block;
  transition: all .8s cubic-bezier(0.29, 1.02, 0.58, 1);

  ${({ isDisabled }) => isDisabled && css`
    cursor: default;
    opacity: 0.6;

    &, &:hover {
      background: #fff;
      color: #eee;
    }
  `}

  ${({ isValid }) => isValid && css`
    color: white;
    background: ${({ theme }) => theme.colors.palette[7]};
  `}
`;

export const BackButton = styled(ModalButton)`
  ${absFull('50%', 'auto', 'auto', '55px')};
  margin-top: -15px;
  padding-left: 20px;

  &:before {
    content: '<';
    position: relative;
    left: -10px;
  }
`;


export const NextButton = styled(ModalButton)`
  ${absFull('50%', '55px', 'auto', 'auto')};
  margin-top: -15px;
  padding-right: 20px;

  &:after {
    content: '>';
    position: relative;
    right: -10px;
  }
`;
